import HttpClient from '../httpClient';
import Root from '../models/root';

const RootService = {

  parseRoot: function(response) {
    if (!response) return null;

    return {
      _links: response._links,
      _forms: response._forms
    };
  },

  getRoot: function() {
    return HttpClient.get('/').then(response => {
      const rootProps = RootService.parseRoot(response);
      return new Root(rootProps);
    });
  }

};

export default RootService;



// WEBPACK FOOTER //
// ./src/api/services/rootService.js